import React, { useState, useEffect, useRef } from "react";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
import Table from "../../components/Table";
import SelectorGenerico from "../../components/SelectorGenerico";
import StateContext from "../../helpers/ContextState";
import { PostAsync, format, Inputs } from "../../helpers/Functions";
import Config from "../../helpers/Config";
import Select from "../../components/Select";
import Input from "../../components/InputSimple";
import SelectorMultiple from "../../components/SelectorMultiple";
import BotonVolverHome from "../../components/BotonVolverHome";
import FormControl from "react-bootstrap/FormControl";
import filterStorage from "../../helpers/filterStorage";

import {
  faEye,
  faDollarSign,
  faPrint,
  faFileWord,
  faMoneyBillAlt
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const App = (props) => {
  const context = React.useContext(StateContext);
  const [param, setParam] = useState({});
  const [data, setData] = useState([]);
  const [btn, setBtn] = useState(false);
  const [inTrash, setInTrash] = useState(false);//This is constant now, eliminado.js deals with deleted
  const [inputs, setInputs] = useState({});
  const [semanas, setSemanas] = useState([]);
  const [total, setTotal] = useState([]);
  const [subTotal, setSubTotal] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [tipoPagos, setTipoPagos] = useState([]);
  //  const [clientes, setClientes]             =   useState([]);
  const [marcas, setMarcas] = useState([]);
  const [productos, setProductos] = useState([]);
  const [inputs2, setInputs2] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [tokensSel, setTokensSel] = useState({});
  const [todoSel, setTodoSel] = useState(false);
  const [usuarioTipo, setUsuarioTipo] = useState([]);
  const [totaltotal, setTotalTotal] = useState({});
  const [totalsubtotal, setTotalSubtotal] = useState({});
  
  //Page system I copied
  const [paginas, setPaginas] = useState([]);
  const [paginaActual, setPaginaActual] = useState({ label: 1, start: 0 });
  const [pageSize, setpageSize] = useState(30);//Hard-coded page limit

  const FILTER_KEY = 'pagos_efectuados_filters_v1';
  const filterSaveEnabled = useRef(false);
  const requestIdRef = useRef(0);

  let filter = "";
  useEffect(() => {
    basicInputs();
    const saved = filterStorage.restore(FILTER_KEY);
    if (saved) {
      if (saved.inputs && Object.keys(saved.inputs).some(k => saved.inputs[k])) {
        setInputs(prev => ({ ...prev, ...saved.inputs }));
      }
      if (saved.inputs2 && Object.keys(saved.inputs2).some(k => Array.isArray(saved.inputs2[k]) && saved.inputs2[k].length > 0)) {
        setInputs2(saved.inputs2);
      }
    }
    setTimeout(() => { filterSaveEnabled.current = true; }, 0);
    return () => { filterStorage.clearIfModuleChanged(FILTER_KEY); };
  }, []);

  useEffect(() => {
    if (param.ma_periodicidad_id) {
      getInit();
    } else {
      setData([]);
    }
  }, [param]);

  useEffect(() => {
    getInit();
  }, [inputs, inputs2]);

  useEffect(() => {
    if (!filterSaveEnabled.current) return;
    filterStorage.save(FILTER_KEY, inputs, inputs2);
  }, [inputs, inputs2]);

  useEffect(() => {
    getInit();
  }, [inTrash, inputs, paginaActual]);

  useEffect(() => {
    setTokensSel({});
    setTodoSel(false);
    setSelectAll(false);
  }, [inTrash, inputs, inputs2, param]);

  const getInit = () => {
    requestIdRef.current += 1;
    const myRequestId = requestIdRef.current;
    setData([]);
    PostAsync(
      "Pagos",
      "ListadoPagosRealizados",
      {
        filtroMultiple: JSON.stringify(inputs2),
        ...param,
        inTrash: inTrash ? 9 : 1,
        ...inputs,
        limit: pageSize,
        start: paginaActual.start,
      },
      context
    ).then((response) => {
      if (myRequestId !== requestIdRef.current) return;
      setUsuarioTipo(response.tipoUsuario)//This just gets the type from the server for the permissions.
      setTotal(response.totalizador);
      setSubTotal(response.subTotalDeudas);
      setTotalTotal(response.total_total);
      setTotalSubtotal(response.total_subtotal);
      if (response.data && response.data.rows) {
        let pagar_ = [];
        /*voy a colocar los inputs activos por defecto para hacer los pagos*/
        response.data.rows.map((row, key) => {
          const marcado = !!tokensSel[row.token];
          pagar_.push({ ...row, uid: row.token, key: key, pagar: todoSel ? !marcado : marcado });
        });
        setData(pagar_);
        setBtn(true);
      }
      let paginacion = Math.ceil(response.data.total_rows / pageSize)
      let pages = []
      let ultimo = 0
      for (var i = 0; i < paginacion; i++) {
        ultimo = pageSize * (i)
        pages.push({ label: i + 1, start: ultimo })
      }
      setPaginas(pages)
    });
  };

  const basicInputs = () => {
    PostAsync(
      "Inventario",
      "ListadoCompras",
      {
        ...param,
        inTrash: inTrash ? 9 : 1,
        fecha: "0000-00-00",
        limit: 0,
        start: 0,
      },
      context
    ).then((response) => {
      if (response.data && response.data.semanas) {
        setSemanas(response.data.semanas);
      }

      if (response.data && response.data.proveedores) {
        setProveedores(response.data.proveedores);
      }

      if (response.data && response.data.marcas) {
        setMarcas(response.data.marcas);
      }

      if (response.data && response.data.productos) {
        setProductos(response.data.productos);
      }

      if (response.data && response.data.tipo_pagos) {
        setTipoPagos(response.data.tipo_pagos);
      }
    });
  };

  const selection = (row, key) => {
    let data_ = [...data];
    data_[key].pagar = data_[key].pagar === true ? false : true;
    setData(data_);
    setBtn(checkActive());

    const nuevos = { ...tokensSel };
    const token = data_[key].token;
    if (todoSel) {
      if (data_[key].pagar) delete nuevos[token]; else nuevos[token] = true;
      setSelectAll(Object.keys(nuevos).length === 0);
    } else {
      if (data_[key].pagar) nuevos[token] = true; else delete nuevos[token];
      setSelectAll(false);
    }
    setTokensSel(nuevos);
  };

  const tokensMarcados = Object.keys(tokensSel);
  const selectedItemsIds = todoSel || tokensMarcados.length === 0 ? "any" : tokensMarcados.join('-');
  const excluirIds = todoSel ? tokensMarcados.join('-') : "";

  const handleCheck = () => {
    let data_ = [];
    let seleccion = selectAll;

    data.map((row, key) => {
      row.pagar = seleccion ? false : true;
      data_.push(row);
    });
    setData(data_);
    setSelectAll(seleccion ? false : true);
    setTodoSel(!seleccion);
    setTokensSel({});
  };

  // console.log("SelectAll", selectAll)
  const handleSubmitPagar = () => {
    if (checkActive()) {
      PostAsync(
        "Pagos",
        "SetPagos",
        { data: JSON.stringify(data) },
        context
      ).then((response) => {
        getInit();
      });
    }
  };

  const eliminarSeleccionados = () => {
    const comprobantes = data
      .filter((row) => row.pagar === true)
      .map((row) => ({ nComprobante: row.nComprobante, proveedor_id: row.proveedor_id }));
    context.setModalShow({ show: false });
    PostAsync(
      "Pagos",
      "SetAnularPagosEfectuadosSeleccionados",
      { comprobantes: JSON.stringify(comprobantes), token: context.user.token },
      context
    ).then(() => {
      setTokensSel({});
      setTodoSel(false);
      setSelectAll(false);
      getInit();
    });
  };

  const handleEliminarSeleccionados = () => {
    const cantidad = data.filter((row) => row.pagar === true).length;
    context.setModalShow({
      show: true,
      message: (
        <div className="text-center">
          <div className="mb-2">¿Estás seguro que deseas eliminar los {cantidad} pagos seleccionados?</div>
          <div className="col ml-auto mr-auto">
            <div className="col-2 btn btn-warning btn-block me-2" onClick={eliminarSeleccionados}>Si</div>
            <div className="col-2 btn btn-secondary btn-block" onClick={() => context.setModalShow({ show: false })}>No</div>
          </div>
        </div>
      ),
      size: "",
    });
  };

  const checkActive = () => {
    const boolean = data.find((search) => search.pagar === true);
    return boolean !== undefined ? true : false;
  };

  const onChangeCustom = (e) => {
    Inputs(e, inputs, setInputs);
  };
  const stripLabels = (obj) => Object.fromEntries(
    Object.entries(obj).map(([k, v]) => [k, Array.isArray(v) ? v.map(({ label, ...r }) => r) : v])
  );
  const objetoSerializado = encodeURIComponent(JSON.stringify(stripLabels(inputs2)));
  return (
    <div className="container">
      <BotonVolverHome />
      <div className="row justify-content-center mb-3">
        <div className="col-12 mb-2">
          <SelectorGenerico
            modelo="Maestros"
            metodo="get_tablas_maestras"
            tabla="ma_periodicidad"
            param={param}
            lg="3"
            name="ma_periodicidad_id"
            setParam={setParam}
          />
        </div>
        <div className="col-3 mb-2">
          <div className="d-grid gap-2">
            {/* <div
              className={
                !inTrash
                  ? "btn btn-warning btn-sm btn-block"
                  : "btn btn-dark btn-sm btn-block"
              }
              onClick={() => {
                setInTrash(inTrash ? false : true);
                // console.log(inTrash)
              }}
            >
              Pagos {!inTrash ? "Eliminados" : "No eliminados"}
            </div> */}
          </div>
        </div>
      </div>

      <div className="row bg-gray">
        <div className="col-12 ">
          <b>Filtros de búsqueda en pagos efectuados</b>
        </div>
        <div className="col-12 col-sm-2 mb-3 pt-1 text-left">
          <Input
            value={inputs.fecha_inicio || ''}
            title="Fecha desde"
            placeholder="Fecha desde"
            type="date"
            name="fecha_inicio"
            className="form-control"
            onChange={onChangeCustom}
            required={true}
          />
        </div>
        <div className="col-12 col-sm-2 mb-3 pt-1 text-left">
          <Input
            value={inputs.fecha_fin || ''}
            title="Fecha hasta"
            placeholder="Fecha hasta"
            type="date"
            name="fecha_fin"
            className="form-control"
            onChange={onChangeCustom}
            required={true}
          />
        </div>
        <div className="col-12 col-sm-2 mb-3 pt-1 text-left border-end">
          <SelectorMultiple
            name="semana"
            title="Semana"
            selectDefault="Semana"
            data={semanas}
            inputs={inputs2}
            setInputs={setInputs2}
            className="form-control"
          />
        </div>
        <div className="col-12 col-sm-2 mb-3 pt-1 text-left border-end">
          <SelectorMultiple
            url="/Usuarios/Lista"
            name="proveedor_id"
            title="Proveedor"
            selectDefault="Proveedor"
            data={proveedores}
            inputs={inputs2}
            setInputs={setInputs2}
            className="form-control"
          />
        </div>
        <div className="col-12 col-sm-2 mb-3 pt-1 text-left border-end">
          <SelectorMultiple
            url="/Usuarios/Lista"
            name="es_tipopago"
            title="Tipo de pago"
            selectDefault="Tipo de pago"
            data={tipoPagos}
            inputs={inputs2}
            setInputs={setInputs2}
            className="form-control"
          />
        </div>
        <div className="col-12 col-sm-2 mb-3 pt-1 text-left border-end">
          <Input
            defaultValue={filter}
            className="form-control"
            name="filter"
            onChange={onChangeCustom}
            placeholder="Buscar por ID o NIT"
            aria-label="Recipient's username"
            aria-describedby="basic-addon2"
          />
        </div>
        <div className="col-12 col-sm-2 mb-3 pt-1 text-left border-end">
          <Input
            className="form-control"
            name="nComprobante"
            onChange={onChangeCustom}
            placeholder="Buscar por comprobante"
          />
        </div>
      </div>

      <div className="row">
        <div className="col">
          <table className="table">
            <thead>
              <tr>
                <th className="col">N. Comprobante</th>
                <th className="col">Fecha de pago</th>
                <th className="col">ID o NIT</th>
                <th className="col">Correo contacto</th>
                <th className="col">Teléfono contacto</th>
                <th className="col">Dirección</th>
                <th className="col">Proveedor</th>
                <th className="col">SubTotal</th>
                <th className="col">T. Pagado</th>
                <th className="text-center col">
                  Acciones
                  <div>
                    {!inTrash && data.length > 0 && usuarioTipo ? (
                      <>
                        <a
                          target="_blank"
                          href={
                            Config.ConfigApirest +
                            "PDF/Pagos/ListadoPagosRealizadosDetalle/"+selectedItemsIds
                            +"?pdfBool=true&fecha_inicio=" +
                            inputs.fecha_inicio +
                            "&fecha_fin=" +
                            inputs.fecha_fin +
                            "&semana=" +
                            inputs.semana +
                            "&ma_periodicidad_id=" +
                            param.ma_periodicidad_id +
                            "&inTrash=" +
                            inTrash +
                            "&filter=" +
                            inputs.filter +
                            "&nComprobante=" +
                            (inputs.nComprobante||'') +
                            "&filtroMultiple=" +
                            objetoSerializado
                          }
                          className="ms-2"
                        >
                          <FontAwesomeIcon icon={faPrint} />
                        </a>
                        <a
                          className="ms-2"
                          target="_blank"
                          href={
                            Config.ConfigApirest +
                            "Excel/Pagos/WordOfficePagosGlobal/filtroMultiple:" +
                            objetoSerializado +
                            "/fecha_inicio:" +
                            inputs.fecha_inicio +
                            "/fecha_fin:" +
                            inputs.fecha_fin +
                            "/ma_periodicidad_id:" +
                            param.ma_periodicidad_id +
                            "/semana:" +
                            inputs.semana +
                            "/seleccion:" +
                            selectedItemsIds +
                            "/excluir:" +
                            excluirIds +
                            "/nComprobante:" +
                            (inputs.nComprobante||'')
                          }
                        >
                          <FontAwesomeIcon icon={faFileWord} />
                        </a>
                        <a
                          className="ms-2"
                          target="_blank"
                          href={
                            Config.ConfigApirest +
                            "Excel/Pagos/ExportarExcelPagosBancolombiaData/filtroMultiple:" +
                            objetoSerializado +
                            "/fecha_inicio:" +
                            inputs.fecha_inicio +
                            "/fecha_fin:" +
                            inputs.fecha_fin +
                            "/ma_periodicidad_id:" +
                            param.ma_periodicidad_id +
                            "/semana:" +
                            inputs.semana +
                            "/seleccion:" +
                            selectedItemsIds +
                            "/nComprobante:" +
                            (inputs.nComprobante||'')
                          }
                        >
                          {/* <FontAwesomeIcon icon={faFileWord} /> */}
                          <FontAwesomeIcon icon={faMoneyBillAlt} />
                        </a>
                      </>
                    ) : (
                      false
                    )}
                  </div>
                </th>
                <th className="text-center col">
                  <div
                    className={
                      selectAll
                        ? "btn btn-primary btn-sm me-2"
                        : "btn btn-secondary btn-sm me-2"
                    }
                    onClick={handleCheck}
                  >
                    <FontAwesomeIcon icon={faCheck} />
                  </div>
                  {!inTrash && data.length > 0 && usuarioTipo && parseInt(context.user.tipo_usuario_id) <= 6 ? (
                    <div className="mt-1">
                      <div
                        className={checkActive() ? "btn btn-danger btn-sm" : "btn btn-secondary btn-sm disabled"}
                        onClick={() => checkActive() && handleEliminarSeleccionados()}
                      >
                        Eliminar pago seleccionado
                      </div>
                    </div>
                  ) : (
                    false
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>Sin resultados...</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              ) : (
                data.map((row, key) => {
                  // console.log(row)
                  return (
                    <tr key={key}>
                      <td>{row.nComprobante}</td>
                      <td>{row.fecha_pago_efectiva_string}</td>
                      <td>{row.id_or_nit}</td>
                      <td>{row.email}</td>
                      <td>{row.celular}</td>
                      <td>{row.direccion}</td>
                      <td>
                        {row.proveedor}
                      </td>
                      {/* <td>{format(parseFloat(( row.peso > 0 )?row.precio * row.peso:row.precio * row.cantidad).toFixed(2))}</td> */}
                      <td>{format(row.subtotal)}</td>
                      <td>{format(row.deuda_provedor)}</td>
                      <td className="text-center border-start">
                        {!inTrash ? (
                          <>
                            <NavLink
                              to={
                                "/Pagos/ListaEfectados/Detalle/" +
                                row.token_proveedor +
                                "/" +
                                row.nComprobante +
                                "?pdfBool=true&fecha_inicio=" +
                                row.fecha_inicio +
                                "&fecha_fin=" +
                                row.fecha_fin +
                                "&semana=" +
                                inputs.semana
                              }
                              className="me-2"
                              title="Ver Detalle"
                            >
                              <FontAwesomeIcon icon={faEye} />
                            </NavLink>
                          </>
                        ) : (
                          <NavLink
                            to={
                              "/Pagos/ListaEfectados/DetalleEliminado/" +
                              row.token_proveedor +
                              "/" +
                              row.nComprobante +
                              "?pdfBool=true&fecha_inicio=" +
                              row.fecha_inicio +
                              "&fecha_fin=" +
                              row.fecha_fin +
                              "&semana=" +
                              inputs.semana
                            }
                            className="btn btn-warning btn-sm"
                          >
                            Detalle
                          </NavLink>
                        )}
                      </td>
                      <td className="text-center ">
                        {parseInt(context.user.tipo_usuario_id) <= 6 ? (
                          <div
                            className={
                              row.pagar === true
                                ? "btn btn-primary btn-sm me-2"
                                : "btn btn-secondary btn-sm me-2"
                            }
                            onClick={() => selection(row, key)}
                          >
                            <FontAwesomeIcon icon={faCheck} />
                          </div>
                        ) : (
                          false
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
            <tfoot>
              <tr className="bg-primary">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="text-end text-white">{format(subTotal)}</td>
                <td className="text-end text-white">{format(total)}</td>
                <td></td>
              </tr>
              <tr className='bg-primary '>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="text-end text-white">{format(totalsubtotal)}</td>
                <td className="text-end text-white">{format(totaltotal)}</td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <div className="d-flex flex-row-reverse">
        <nav aria-label="Programandoweb, siempre lo hacemos bien">
          <ul className="pagination">
            {paginas.map((page, num) => (
              <li key={num} className={num+1===paginaActual.label?"page-item active":"page-item "} onClick={()=>{setPaginaActual(page)}}>
                <a className={num+1===paginaActual.label?"page-link   mr-1":"page-link mr-1"} >{num+1}</a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
};
export default App;